import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hotels: [],
  page: 1,
  total: 0,
  totalPages: 0,
  scrollY: 0,
};

const hotelSlice = createSlice({
  name: "hotels",
  initialState,
  reducers: {
    setHotels: (state, action) => {
      state.hotels = action.payload;
    },
    addHotels: (state, action) => {
      const merged = [...state.hotels, ...action.payload];
      state.hotels = merged.filter(
        (hotel, index, self) =>
          index === self.findIndex((h) => h._id === hotel._id)
      );
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setScrollY: (state, action) => {
      state.scrollY = action.payload;
    },
    resetHotels: () => initialState,
  },
});

export const {
  setHotels,
  addHotels,
  setPage,
  setTotal,
  setTotalPages,
  setScrollY,
  resetHotels,
} = hotelSlice.actions;

export default hotelSlice.reducer;
